var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessThanEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9593 11.2464L7.70928 7.49635L13.9593 3.74635C14.0414 3.69711 14.1118 3.63379 14.1667 3.56003C14.2216 3.48626 14.2598 3.40349 14.2792 3.31644C14.2985 3.22938 14.2986 3.13975 14.2795 3.05266C14.2603 2.96557 14.2223 2.88272 14.1676 2.80885C14.1129 2.73498 14.0425 2.67154 13.9606 2.62214C13.8786 2.57274 13.7866 2.53835 13.6899 2.52094C13.5932 2.50353 13.4936 2.50344 13.3968 2.52066C13.3001 2.53789 13.208 2.57211 13.1259 2.62135L6.04094 6.87235C5.92681 6.94085 5.83323 7.03364 5.76851 7.14249C5.70379 7.25134 5.66992 7.37289 5.66992 7.49635C5.66992 7.61981 5.70379 7.74136 5.76851 7.85022C5.83323 7.95907 5.92681 8.05186 6.04094 8.12035L13.1259 12.3714C13.208 12.4206 13.3001 12.4548 13.3968 12.472C13.4936 12.4893 13.5932 12.4892 13.6899 12.4718C13.7866 12.4544 13.8786 12.42 13.9606 12.3706C14.0425 12.3212 14.1129 12.2577 14.1676 12.1839C14.2223 12.11 14.2603 12.0271 14.2795 11.94C14.2986 11.853 14.2985 11.7633 14.2792 11.6763C14.2598 11.5892 14.2216 11.5064 14.1667 11.4327C14.1118 11.3589 14.0414 11.2956 13.9593 11.2464Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.75H5.83333C5.61232 15.75 5.40036 15.671 5.24408 15.5303C5.0878 15.3897 5 15.1989 5 15C5 14.8011 5.0878 14.6103 5.24408 14.4697C5.40036 14.329 5.61232 14.25 5.83333 14.25H14.1667C14.3877 14.25 14.5996 14.329 14.7559 14.4697C14.9122 14.6103 15 14.8011 15 15C15 15.1989 14.9122 15.3897 14.7559 15.5303C14.5996 15.671 14.3877 15.75 14.1667 15.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessThanEqual);
export default __webpack_public_path__ + "static/media/less-than-equal.857bdc9b53edab520c5600ed792339e2.svg";
export { ForwardRef as ReactComponent };